import { useState } from 'react';
import type { ItemRaid } from '../../api/raid.js';

const ESCALA = [5, 4, 3, 2, 1] as const;

function corCelula(prob: number, impacto: number): string {
  const valor = prob * impacto;
  if (valor >= 15) return 'bg-status-vermelho/20';
  if (valor >= 10) return 'bg-status-ambar/25';
  if (valor >= 5) return 'bg-status-ambar/10';
  return 'bg-status-verde/10';
}

// SPEC-UX §4.7 — matriz 5x5 clicável como visão alternativa; célula abre
// os itens dela. Só Risk tem probabilidade/impacto — outras categorias não
// aparecem na matriz (por design, a matriz é sobre risco).
export function MatrizRaid({ itens }: { itens: ItemRaid[] }) {
  const [celulaAberta, setCelulaAberta] = useState<{ prob: number; impacto: number } | null>(null);
  const risks = itens.filter((i) => i.categoria === 'Risk' && i.probabilidade && i.impacto);

  const itensDaCelula = celulaAberta ? risks.filter((r) => r.probabilidade === celulaAberta.prob && r.impacto === celulaAberta.impacto) : [];

  return (
    <div>
      <table className="border-collapse">
        <tbody>
          {ESCALA.map((prob) => (
            <tr key={prob}>
              <th className="fonte-mono w-6 pr-2 text-right text-xs text-grafite">{prob}</th>
              {ESCALA.slice()
                .reverse()
                .map((impacto) => {
                  const contagem = risks.filter((r) => r.probabilidade === prob && r.impacto === impacto).length;
                  return (
                    <td key={impacto} className="p-0.5">
                      <button
                        type="button"
                        onClick={() => setCelulaAberta({ prob, impacto })}
                        className={`flex h-10 w-10 items-center justify-center rounded text-xs font-medium text-ink ${corCelula(prob, impacto)} hover:ring-2 hover:ring-aco`}
                      >
                        {contagem > 0 ? contagem : ''}
                      </button>
                    </td>
                  );
                })}
            </tr>
          ))}
          <tr>
            <th />
            {ESCALA.slice()
              .reverse()
              .map((impacto) => (
                <th key={impacto} className="fonte-mono pt-1 text-xs text-grafite">
                  {impacto}
                </th>
              ))}
          </tr>
        </tbody>
      </table>
      <p className="fonte-mono mt-1 text-[10px] text-grafite">probabilidade (linhas) × impacto (colunas)</p>

      {celulaAberta && (
        <div className="mt-4 rounded border border-borda bg-superficie p-3">
          <div className="mb-2 flex items-center justify-between">
            <p className="text-xs font-semibold text-grafite">
              Prob {celulaAberta.prob} × Impacto {celulaAberta.impacto}
            </p>
            <button type="button" onClick={() => setCelulaAberta(null)} className="text-xs text-grafite hover:text-ink">
              fechar
            </button>
          </div>
          {itensDaCelula.length === 0 ? (
            <p className="text-xs text-grafite">Nenhum item nesta célula.</p>
          ) : (
            <ul className="flex flex-col gap-1">
              {itensDaCelula.map((item) => (
                <li key={item.id} className="text-sm text-ink">
                  {item.descricao} <span className="fonte-mono text-xs text-grafite">({item.estado})</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
